exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vouchers-header {\n    width: 70%;\n    margin-bottom: 45px;\n}\n\n@media (max-width: 768px) {\n    .vouchers-header {\n        display: none;\n    }\n}", ""]);

// exports
